<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <b-row class="margin-0 padding-x-8">
        <b-col
          v-for="(item, index) in items"
          :key="index"
          cols="12"
          class="border--solid border--complementary-50 border-radius-8 padding-8 margin-bottom-8 flex-between"
        >
          <div class="width-percent-50">
            <div class="flex-start margin-bottom-12">
              <b-skeleton width="70%"></b-skeleton>
              <b-skeleton
                type="button"
                class="height-25 width-percent-20 margin-right-8"
              ></b-skeleton>
            </div>
            <b-skeleton width="70%"></b-skeleton>
          </div>
          <div class="width-percent-50">
            <div class="flex-end margin-bottom-16 width-percent-100">
              <b-skeleton
                type="button"
                class="height-25 width-percent-5 margin-left-8"
              ></b-skeleton>
              <b-skeleton
                type="button"
                class="height-25 width-percent-5"
              ></b-skeleton>
            </div>
            <div class="flex-end-end flex-direction-column width-percent-100">
              <b-skeleton width="70%"></b-skeleton>
              <b-skeleton width="70%"></b-skeleton>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
    <slot name="default"></slot>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 6,
    },
  },
  computed: {
    items() {
      const arr = [];
      arr.length = this.count;
      return arr;
    },
  },
};
</script>
